import { useState, useEffect } from 'react';
import { cn } from '../../utils/cn';

interface LoadingTimeoutProps {
  /** Tid i ms før timeout-melding vises */
  timeout?: number;
  /** Loading state - når false, resettes timeout */
  isLoading: boolean;
  /** Variant for styling */
  variant?: 'light' | 'dark';
  /** Tekst som vises under spinner */
  loadingText?: string;
}

export function LoadingTimeout({
  timeout = 8000,
  isLoading,
  variant = 'light',
  loadingText = 'Laster...'
}: LoadingTimeoutProps) {
  const [showTimeout, setShowTimeout] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShowTimeout(false);
      return;
    }

    const timer = setTimeout(() => {
      setShowTimeout(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [isLoading, timeout]);

  const isDark = variant === 'dark';

  if (!showTimeout) {
    return (
      <div className="text-center">
        <div 
          className={cn(
            'animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4',
            isDark ? 'border-condo-light' : 'border-condo-dark'
          )} 
        />
        <p className={cn('text-lg', isDark ? 'text-condo-light' : 'text-gray-700')}>
          {loadingText}
        </p>
      </div>
    );
  }

  return (
    <div className="text-center">
      <p className={cn('text-lg mb-2', isDark ? 'text-condo-light' : 'text-gray-700')}>
        Dette tar lenger tid enn forventet...
      </p>
      <p className={cn('text-sm mb-6', isDark ? 'text-condo-light/70' : 'text-gray-500')}>
        Det kan skyldes nettverksproblemer eller en midlertidig feil.
      </p>
      <button
        onClick={() => window.location.reload()}
        className={cn(
          'px-6 py-3 rounded-lg font-medium transition-colors',
          isDark 
            ? 'bg-condo-light text-condo-dark hover:bg-white' 
            : 'bg-condo-dark text-white hover:bg-condo-med'
        )}
      >
        Last siden på nytt
      </button>
    </div>
  );
}

